import { withFormik } from 'formik'
import { compose, withHandlers, mapProps } from 'recompose'

import { required } from 'utils/validation'
import { formatDate, LOCAL_DATE_FORMAT } from 'utils/date'

import { FORM_PROGRESS_STATUS, FORM_SUBMIT_STATUS } from 'constants/form'

export default compose(
  mapProps((props) => {
    return {
      onFormSubmit: props.onFormSubmit,
      organisation: props.organisation,
      createdDate: formatDate(props.organisation.createdAt, LOCAL_DATE_FORMAT)
    }
  }),
  withFormik({
    // Transform outer props into form values
    mapPropsToValues: props => ({
      name: props.organisation.name,
      image: props.organisation.imageUrl,
    }),
    // Add a custom validation function (this can be async too!)
    validate: ({ name }) => {
      const errors = {}
      if (required(name)) {
        errors.name = 'Please enter a valid project name'
      }

      return errors
    },
    enableReinitialize: true,
    validateOnChange: false,
    handleSubmit: (values, {
      props, setSubmitting,
    }) => {
      setSubmitting(true)
      // If form has no error
      if (props.onFormSubmit) {
        props.onFormSubmit(props.organisation, values)
      }
    },
  }),
  // Handlers
  withHandlers({
    handleFieldChange: props => (event) => {
      props.setStatus(FORM_PROGRESS_STATUS)
      props.handleChange(event)
    },
    handleImageRemoved: props => () => {
      props.setFieldValue('image', null, true)
    },
    handleImageChange: props => (acceptedFile) => {
      if (acceptedFile) {
        props.setFieldValue('image', acceptedFile, true)
      }
    },
    handleFormSubmit: props => (event) => {
      props.setStatus(FORM_SUBMIT_STATUS)
      props.handleSubmit(event)
    },
    hasFieldError: props => (fieldName) => {
      return !!((props.errors[fieldName] && props.errors[fieldName].length && props.status === FORM_SUBMIT_STATUS))
    },
  }),
)




// WEBPACK FOOTER //
// ./src/components/organisms/EditOrganisationForm/EditOrganisationForm.enhancer.js